.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--hs-spacing-2);
  padding: var(--hs-button-pad-y) var(--hs-button-pad-x);
  border: 0;
  border-radius: var(--hs-radius-full);
  font: var(--hs-type-label);
  letter-spacing: var(--hs-label-ls);
  white-space: nowrap;
  /* For a link drawn as a button (buttonClassName). */
  text-decoration: none;
  cursor: pointer;
  transition:
    background-color 120ms ease,
    box-shadow 120ms ease,
    color 120ms ease;
}
.button:focus-visible {
  outline: none;
  box-shadow: var(--hs-focus-lavender);
}
.button:disabled {
  cursor: not-allowed;
  box-shadow: none;
}
.icon {
  flex: none;
}
/* A label made of several pieces (a glyph and words) keeps them apart. */
.label {
  display: inline-flex;
  align-items: center;
  gap: var(--hs-spacing-2);
}
.fullWidth {
  width: 100%;
}
.sm {
  padding: 7px 14px;
}

.primary {
  background: var(--hs-color-primary-default);
  color: var(--hs-color-text-on-primary);
  box-shadow: var(--hs-shadow-xs);
}
.primary:hover:not(:disabled) {
  background: var(--hs-color-primary-hover);
  box-shadow: var(--hs-shadow-sm);
}
.primary[aria-pressed='true'],
.primary:active:not(:disabled) {
  background: var(--hs-color-primary-hover);
  box-shadow: var(--hs-focus-lavender);
}
.primary:disabled {
  background: var(--hs-color-border-default);
  color: color-mix(in srgb, var(--hs-color-text-secondary) 50%, transparent);
}

.secondary {
  background: var(--hs-color-secondary-default);
  color: var(--hs-color-text-on-primary);
  box-shadow: var(--hs-shadow-xs);
}
.secondary:hover:not(:disabled) {
  background: var(--hs-color-secondary-hover);
  box-shadow: var(--hs-shadow-sm);
}
.secondary:focus-visible {
  box-shadow: var(--hs-focus-olive);
}
.secondary[aria-pressed='true'],
.secondary:active:not(:disabled) {
  background: var(--hs-color-secondary-container);
  color: var(--hs-color-secondary-on-container);
  box-shadow: var(--hs-focus-olive);
}
.secondary:disabled {
  background: var(--hs-color-bg-subtle);
  color: color-mix(in srgb, var(--hs-color-text-secondary) 50%, transparent);
}

.ghost {
  background: var(--hs-color-bg-sunken);
  color: var(--hs-color-secondary-hover);
}
.ghost:hover:not(:disabled) {
  background: var(--hs-color-border-default);
  color: var(--hs-color-text-primary);
}
.ghost[aria-pressed='true'],
.ghost:active:not(:disabled) {
  background: var(--hs-color-secondary-container-soft);
  color: var(--hs-color-secondary-deep);
}
.ghost:disabled {
  background: var(--hs-color-bg-surface);
  color: color-mix(in srgb, var(--hs-color-text-secondary) 30%, transparent);
}

.text {
  background: transparent;
  color: var(--hs-color-primary-default);
}
.text:hover:not(:disabled) {
  background: var(--hs-color-primary-container);
  color: var(--hs-color-primary-on-container);
}
.text[aria-pressed='true'],
.text:active:not(:disabled) {
  background: var(--hs-color-primary-container);
  color: var(--hs-color-primary-deep);
}
.text:disabled {
  color: color-mix(in srgb, var(--hs-color-text-secondary) 40%, transparent);
}
